export default __webpack_public_path__ + "static/media/smvs_text_logo.ec8a578a.png";